import { render, staticRenderFns } from "./QScoreCardPlaced.vue?vue&type=template&id=36c79528&scoped=true&"
import script from "./QScoreCardPlaced.vue?vue&type=script&lang=js&"
export * from "./QScoreCardPlaced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c79528",
  null
  
)

export default component.exports